/*global gsap, ScrollTrigger, ajax_object */
// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
// import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * GSAP Scrolling
   */

  if (window.innerWidth >= 1280) {
    gsap.registerPlugin(ScrollTrigger);

    const contentItems = document.querySelectorAll('.content__item--image');

    contentItems.forEach((item, index) => {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.home-content__wrapper',
          start: 'top 20%',
          end: 'bottom bottom',
          scrub: 1,
          pin: item,
          // markers: { startColor: 'green', endColor: 'red' },
        },
      });

      const tlScroll = gsap.timeline({
        scrollTrigger: {
          trigger: `.content__item[data-item-number="${index + 1}"]`,
          start: '40% 80%',
          end: '40% 80%',
          // markers: { startColor: 'blue', endColor: 'black' },
          scrub: true,
          toggleActions: 'play reverse play reverse',
        },
      });

      tlScroll.from(`.content__item[data-item-number="${index + 1}"] img`, {
        yPercent: 100,
        stagger: 0.2,
      });

      tlScroll.to(`.content__item[data-item-number="${index + 1}"] img`, {
        yPercent: 0,
        stagger: 0.2,
      });
    });
  }

  /**
   * GSAP Scrolling Attorneys
   */

  if (window.innerWidth >= 1024) {
    const item = document.querySelectorAll('.lawyers-images');
    const itemSingle = document.querySelector('.lawyers-images');

    if (itemSingle) {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.lawyers-images',
          start: 'top 20%',
          endTrigger: '.lawyers-cards',
          end: () => 'bottom 20%+=' + itemSingle.offsetHeight,
          duration: 1,
          scrub: 1,
          pin: item,
          toggleActions: 'revers none revers none',
          // markers: { startColor: 'red', endColor: 'blue' },
        },
      });
    }
  }

  /**
   * Testimonials Slider and Resources Slider
   */

  function updateMatchHeight() {
    if ($(window).width() >= 640) {
      $('.testimonials__slider--wrapper, .resources__slider--wrapper').addClass(
        'matchHeight'
      );
      $('.matchHeight').matchHeight();
    } else {
      $(
        '.testimonials__slider--wrapper, .resources__slider--wrapper'
      ).removeClass('matchHeight');
    }
  }

  $('.resources__slider').css('display', 'block');
  $('.testimonials__slider').css('display', 'block');
  $('.testimonials__slider, .resources__slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    prevArrow: '<div class="arrow-slider arrow-slider-prev"></div>',
    nextArrow: '<div class="arrow-slider arrow-slider-next"></div>',
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
  });

  // Initial update
  updateMatchHeight();

  // Update on window resize
  $(window).resize(function () {
    updateMatchHeight();
  });

  function ClassDotsManager(slickElementId, numOfItems, numOfDots) {
    this.listDotsElement = $('.' + slickElementId + ' ul.slick-dots li');
    this.numOfDots = numOfDots <= numOfItems ? numOfDots : numOfItems;
    this.minIndex = 0;
    this.maxIndex = numOfDots - 1;
    this.showDotsBetween = function (minIndex, maxIndex) {
      this.listDotsElement.filter(function (index) {
        $(this).css(
          'display',
          index + 1 >= minIndex && index < maxIndex ? 'inline-block' : 'none'
        );
      });
    };
    this.init = function () {
      this.showDotsBetween(0, this.numOfDots - 1);
    };
    this.updateDots = function (newIndex) {
      if (newIndex > this.maxIndex) {
        this.maxIndex = newIndex;
        this.minIndex = this.maxIndex - this.numOfDots + 1;
      } else {
        this.minIndex = newIndex;
        this.maxIndex = this.minIndex + this.numOfDots - 1;
      }
      console.log(this.minIndex);
      this.showDotsBetween(this.minIndex, this.maxIndex);
    };
  }

  //=====================================================================
  // usage (with "small-preview" is the id of div that is used for slick)
  //=====================================================================
  var numberOfItems = $('.slick-slide').length; //get number of pictures on the slide
  var dotsManager = new ClassDotsManager('resources__slider', numberOfItems, 3);
  dotsManager.init();

  $('.resources__slider').on('afterChange', function (slick, currentSlide) {
    dotsManager.updateDots(currentSlide.currentSlide);
  });

  /**
   * Add Practice Areas Items Hover
   */

  $('.practice__links--item').mouseenter(function () {
    var currentItem = $(this).data('item');

    $('.practice__images--item').removeClass('active');

    $(".practice__images--item[data-item='" + currentItem + "']").addClass(
      'active'
    );
  });

  /**
   * Add Lawyers Areas Items Hover
   */

  function linkHoverImage() {
    if ($(window).width() >= 1024) {
      $('.lawyers-cards__item--link').mouseenter(function () {
        $('.lawyers-cards__item--link').removeClass('active');
        $(this).addClass('active');

        var dataItemValue = $(this).data('item');

        $('.lawyers-images__item[data-item]').each(function () {
          var imageDataItemValue = $(this).data('item');
          if (parseInt(imageDataItemValue) <= parseInt(dataItemValue)) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      });
    }
  }

  linkHoverImage();

  $(window).resize(function () {
    linkHoverImage();
  });

  /**
   * Add Lawyers Areas Items Slider
   */

  // function updateSlider() {
  //   if ($(window).width() <= 1023) {
  //     $('.lawyers-cards .slick-slide').addClass('matchHeight');
  //     $('.matchHeight').matchHeight();
  //
  //     $('.lawyers-cards').slick({
  //       infinite: false,
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       prevArrow: '<div class="arrow-slider arrow-slider-prev"></div>',
  //       nextArrow: '<div class="arrow-slider arrow-slider-next"></div>',
  //     });
  //   }
  // }
  //
  // updateSlider();
  //
  // $(window).resize(function () {
  //   updateSlider();
  // });

  function updateSlider() {
    const $lawyersCards = $('.lawyers-cards');

    if ($(window).width() <= 1023) {
      if (
        $lawyersCards.length &&
        !$lawyersCards.hasClass('slick-initialized')
      ) {
        $lawyersCards.slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          accessibility: false,
          arrows: true,
          prevArrow: '<div class="arrow-slider arrow-slider-prev"></div>',
          nextArrow: '<div class="arrow-slider arrow-slider-next"></div>',
        });
        $('.lawyers-cards .slick-slide').addClass('matchHeight');
        $('.matchHeight').matchHeight();
      }
    } else {
      if ($lawyersCards.length && $lawyersCards.hasClass('slick-initialized')) {
        $lawyersCards.slick('unslick');
        $lawyersCards.find('.slick-slide').removeClass('matchHeight');
      }
    }
  }

  updateSlider();

  $(window).on('resize', function () {
    updateSlider();
  });

  /**
   * Add Menu Slider on Header
   */

  // $('.menu-slider').slick({
  //   autoplay: true,
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: true,
  // });

  $('.menu_attorney .sub-menu').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-slider arrow-slider-prev"></div>',
    nextArrow: '<div class="arrow-slider arrow-slider-next"></div>',
    arrows: true,
    dots: false,
    lazyLoad: 'ondemand',
  });

  /**
   * Add Scroll Down on Hero Arrow Click
   */

  function scrollToSection(buttonSelector, sectionSelector) {
    var button = document.querySelector(buttonSelector);
    var section = document.getElementById(sectionSelector);

    if (button) {
      button.addEventListener('click', function () {
        var sectionHeight = section.offsetHeight;

        window.scrollTo({
          top: section.offsetTop + sectionHeight,
          behavior: 'smooth',
        });
      });
    }
  }

  scrollToSection('.down-button', 'hero');
  scrollToSection('.down-button__attorney', 'attorney-hero');

  /**
   * Add Hover on Header menu
   */

  $('.header .menu-item-has-children, .header-phone__menu').hover(
    function () {
      $(this).find('a').addClass('active');
      $(this).find('.mega-menu').addClass('active');
      $('.header-phone__menu').addClass('active');
    },
    function () {
      $(this).find('a').removeClass('active');
      $(this).find('.mega-menu').removeClass('active');
      if (!$(this).is('.header-phone__menu:hover')) {
        $('.header-phone__menu').removeClass('active');
      }
    }
  );

  $('.header-phone').hover(
    function () {
      $('.header-phone__menu').addClass('active');
    },
    function () {
      if (!$(this).is('.header-phone__menu:hover')) {
        $('.header-phone__menu').removeClass('active');
      }
    }
  );

  $('.menu-icon').click(function () {
    $('.mobile-menu').addClass('active');
    $('body').addClass('scroll');
  });

  $('.mobile-top__close-button').click(function () {
    $('.mobile-menu').removeClass('active');
    $('body').removeClass('scroll');
  });

  /**
   * Add Change Size on Scroll
   */

  var $hero = $('.hero');
  var $header = $('.header');

  function handleScroll() {
    if ($(window).scrollTop() > 0) {
      $hero.addClass('narrow');
      $header.addClass('header-full');
    } else {
      $hero.removeClass('narrow');
      $header.removeClass('header-full');
    }
  }

  // Initial check on page load
  handleScroll();

  // Listen for scroll events
  $(window).scroll(handleScroll);

  /**
   * Add show/hide on mobile in Team Tabs
   */

  $('.plus').click(function () {
    $('.plus, .team-tabs__wrapper').toggleClass('no-hide');
  });

  /**
   * Show post list
   */
  $('.show-post-btn').click(function () {
    $(this).toggleClass('active');
    $('.post-type__list').toggleClass('show-post');
  });

  $('.close-post-btn').click(function () {
    $('.post-type__list').removeClass('show-post');
    $('.show-post-btn').removeClass('active');
  });
  /**
   * Blog filtration
   */
  let postPerPage = 9;
  // let loadPost = $('.post__wrapper').length;
  var canBeLoaded = true;

  function loadScrollPosts(response, taxonomy = false) {
    let offset = taxonomy ? 0 : $('.post__wrapper').length;
    let post = $('.resources__filter--types').find('.active').data('post');
    let name = $('.resources__filter--types').find('.active').data('name');
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: ajax_object.ajax_url,
      data: {
        action: 'loadmore',
        post: post,
        offset: offset,
        postperpage: postPerPage,
      },
      beforeSend: function () {
        canBeLoaded = false;
      },
      success: function (response) {
        if (taxonomy) {
          $('.ajax-posts').html(response.html);
          $('.show-cat-btn__text').text(name);
          $('.post-type__list').removeClass('show-post');
          $('.reset').css('display', 'flex');
          $('.show-post-btn').removeClass('active');
        } else {
          $('.ajax-posts').append(response.html);
        }
        if ($('.post__wrapper').length > response.post_count) {
          $('.ajax-all-posts').show();
        }
        $('.reset').click(function () {
          setTimeout(function () {
            $('.reset').css('display', 'none');
          }, 2500);
        });
        canBeLoaded = true;
      },
      error: function (result) {
        console.warn(result);
      },
    });
    return false;
  }

  $('.post-name').click(function (e) {
    e.preventDefault();
    $('.post-name').removeClass('active');
    $(this).addClass('active');
    loadScrollPosts('response', true);
  });

  if (
    $('body').hasClass('page-template-template-resources') === true ||
    $('body').hasClass('blog') === true ||
    $('body').hasClass('archive') === true
  ) {
    $(window).scroll(function (response, taxonomy = false) {
      let bottomOffset =
        $('.resources').offset().top + $('.resources').height();
      if (
        $(window).scrollTop() + $(window).height() >= bottomOffset &&
        canBeLoaded === true
      ) {
        loadScrollPosts(response, taxonomy);
      }
    });
  }
  /**
   * Add fancybox Single Popup
   */
  $('a.selector').on('click', function (e) {
    var $toggle = $(this),
      productID = $toggle.data('post_id');
    e.preventDefault();
    $.fancybox.open({
      src: ajax_object.url,
      type: 'ajax',
      opts: {
        animationDuration: 366,
        animationEffect: 'slide-in-out',
        centerOnScroll: true,
        autoFocus: false,
        ajax: {
          settings: {
            dataType: 'html',
            type: 'POST',
            data: {
              post_id: productID,
              action: 'get_post_content',
              nonce: ajax_object.nonce,
            },
          },
        },
      },
    });
  });
  /**
   *Video Library Ajax filter
   */
  // $('.video-type___title').on('click', function () {
  //   var category = $(this).data('name');
  //
  //   $.ajax({
  //     url: ajax_object.ajax_url,
  //     type: 'POST',
  //     data: {
  //       action: 'filter_videos_by_category',
  //       category: category,
  //     },
  //     success: function (response) {
  //       $('.video-library__wrapper').html(response);
  //       $('.reset-video').addClass('active');
  //       $('.show-cat-btn__text').text(category);
  //       $('.video-type__list').removeClass('show-post');
  //       $('.show-post-btn').removeClass('active');
  //     },
  //     error: function (result) {
  //       console.warn(result);
  //     },
  //   });
  // });
  //
  // $('.reset-video').on('click', function () {
  //   $.ajax({
  //     url: ajax_object.ajax_url,
  //     type: 'POST',
  //     data: {
  //       action: 'reset_video_filter',
  //     },
  //     success: function (response) {
  //       $('.video-library__wrapper').html(response);
  //       $('.reset-video').removeClass('active');
  //       $('.show-cat-btn__text').text('Category');
  //       $('.video-type__list').removeClass('show-post');
  //     },
  //     error: function (result) {
  //       console.warn(result);
  //     },
  //   });
  // });

  // $('.video-type___title').on('click', function () {
  //   var category = $(this).data('name');
  //
  //   updateVideos(category);
  // });
  //
  // $('.reset-video').on('click', function () {
  //   updateVideos('');
  // });
  //
  // function updateVideos(category) {
  //   var requestData = {
  //     url: ajax_object.ajax_url,
  //     type: 'POST',
  //     data: {
  //       action: category ? 'filter_videos_by_category' : 'reset_video_filter',
  //       category: category,
  //     },
  //     success: function (response) {
  //       $('.video-library__wrapper').html(response);
  //       $('.reset-video').toggleClass('active', !!category);
  //       $('.show-cat-btn__text').text(category || 'Category');
  //     },
  //     error: function (result) {
  //       console.warn(result);
  //     },
  //   };
  //
  //   if (!category) {
  //     requestData.data = { action: 'reset_video_filter' };
  //   }
  //
  //   $.ajax(requestData);
  // }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    // cssProps: {
    //   visibleY: true,
    //   viewportY: true,
    //   scrollPercentY: true,
    // },
    threshold: 0.3,
    once: true,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  $('.legal-services-mobile__title').on('click', function () {
    $(this).toggleClass('active');
    $('.legal-services-mobile-menu').slideToggle();
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
// $(window).on('load', function () {
//   // jQuery code goes here
//
//   let $preloader = $('.preloader');
//   if ($preloader.length) {
//     $preloader.addClass('preloader--hidden');
//   }
// });

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
